<template>
  <v-dialog max-width="1096" v-model="dialog" fullscreen>
    <template v-slot:activator="{on, attrs}">
      <v-btn v-on="on" v-bind="attrs" color="primary" :class="className">
        История операций
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title> История операций</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn dark text @click="dialog = false">Закрыть</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-data-table :headers="headers" :items="protocols" :hide-default-footer="true" :disable-pagination="true" :dense="true" :onscroll="true"/>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import ReturnOrderService from "@/services/return.order.service";
import moment from "moment";
import {getActionText, reasonText} from "@/enum/StatusAction";

export default {
  name: "ReturnOrderProtocol",
  props: {
    id: {
      type: Number,
      default: 0
    },
    order: {
      type: Object,
      default() {
        return null
      }
    },
    className: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialog: false,
      protocols: [],
      headers: [
        {text: 'Действие', sortable: false, value: 'actionText'},
        {text: "Дата", sortable: false, value: "date", width: "120px"},
        {text: "Время", sortable: false, value: "time"},
        {text: 'Сторона', sortable: false, value: 'companyInn'},
        {text: 'Причина', sortable: false, value: 'text'},
        {text: "Комментарий", sortable: false, value: "comment"},
        {text: "Пользователь", sortable: false, value: "userName"},
        {text:"Номер накладная ", sortable: false,value:"shipmentNumber"}
      ],
    }
  },
  methods: {
    loadProtocols() {
      this.$store.dispatch(LAYOUT_LOADING_START)

      ReturnOrderService.orderProtocol(this.id)
          .then(response => {
            this.protocols = response.data.map(protocol => {
              const date = moment(protocol.CreatedDate)
              let company = protocol.CompanyInn;

              if (this.order) {
                if (protocol.CompanyInn === this.order.executorInn) {
                  company = "Поставщик"
                } else if (protocol.CompanyInn === this.order.customerInn) {
                  company = "Заказчик"
                }
              }

              return {
                id: protocol.Id,
                actionText: getActionText(protocol.Action),
                date: date.format('DD.MM.YYYY'),
                time: date.format('HH:mm:ss'),
                companyInn: company,
                userName: protocol.UserName,
                shipmentWaybillId: protocol.ShipmentWaybillId ? protocol.ShipmentWaybillId : null,
                invoiceId: protocol.InvoiceId ? protocol.InvoiceId : null,
                returnInvoiceId: protocol.ReturnInvoiceId ? protocol.ReturnInvoiceId : null,
                text: reasonText(protocol.Action, protocol.Reason),
                comment: protocol.Comment ? protocol.Comment : null,
                shipmentNumber:protocol.Shipment?protocol.Shipment.Number : null
              }
            })
          }).catch(error => {
        window.console.log(error)
      }).finally(() => {
        this.$store.dispatch(LAYOUT_LOADING_STOP)
      })
    }
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.loadProtocols()
      }
    }
  }
}
</script>

<style scoped>

</style>